import Avatar from "@mui/material/Avatar";

export default function UserAvatar(props) {
	let { user } = props;
	if (!user?.id) {
		return;
	}

	const size = props?.size || 20;

	return (
		<Avatar src={user.profilePicture || '/null.png'} alt={user?.firstName + ' ' + user?.lastName} title={user?.firstName + ' ' + user?.lastName} sx={{ height: size, width: size, bgcolor: user.colour }}>
			{user?.firstName?.charAt(0)}
		</Avatar>
	);
}
